import React from 'react'
const mainservice=[{
   id:1,
   icon:`./Assets/icons/service-icon-1.png`,
   heading:`Cloud Services`,
   para:`Deliver plug commerce with dynamic is expertise. leading edge products with business models`,
},
{
  id:2,
  icon:`./Assets/icons/service-icon-1.png`,
  heading:`Cloud Services`,
  para:`Deliver plug commerce with dynamic is expertise. leading edge products with business models`,
},
{
  id:3,
  icon:`./Assets/icons/service-icon-1.png`,
  heading:`Cloud Services`,
  para:`Deliver plug commerce with dynamic is expertise. leading edge products with business models`,
},

{
  id:4,
  icon:`./Assets/icons/service-icon-1.png`,
  heading:`Cloud Services`,
  para:`Deliver plug commerce with dynamic is expertise. leading edge products with business models`,
},
{
  id:5,
  icon:`./Assets/icons/service-icon-1.png`,
  heading:`Cloud Services`,
  para:`Deliver plug commerce with dynamic is expertise. leading edge products with business models`,
},
{
  id:6,
  icon:`./Assets/icons/service-icon-1.png`,
  heading:`Cloud Services`,
  para:`Deliver plug commerce with dynamic is expertise. leading edge products with business models`,
},
{
  id:7,
  icon:`./Assets/icons/service-icon-1.png`,
  heading:`Cloud Services`,
  para:`Deliver plug commerce with dynamic is expertise. leading edge products with business models`,
},
{
  id:8,
  icon:`./Assets/icons/service-icon-1.png`,
  heading:`Cloud Services`,
  para:`Deliver plug commerce with dynamic is expertise. leading edge products with business models`,
},
{
  id:9,
  icon:`./Assets/icons/service-icon-1.png`,
  heading:`Cloud Services`,
  para:`Deliver plug commerce with dynamic is expertise. leading edge products with business models`,
},
{
  id:10,
  icon:`./Assets/icons/service-icon-1.png`,
  heading:`Cloud Services`,
  para:`Deliver plug commerce with dynamic is expertise. leading edge products with business models`,
},
{
  id:11,
  icon:`./Assets/icons/service-icon-1.png`,
  heading:`Cloud Services`,
  para:`Deliver plug commerce with dynamic is expertise. leading edge products with business models`,
},
{
  id:12,
  icon:`./Assets/icons/service-icon-1.png`,
  heading:`Cloud Services`,
  para:`Deliver plug commerce with dynamic is expertise. leading edge products with business models`,
},
{
  id:13,
  icon:`./Assets/icons/service-icon-1.png`,
  heading:`Cloud Services`,
  para:`Deliver plug commerce with dynamic is expertise. leading edge products with business models`,
},
{
  id:14,
  icon:`./Assets/icons/service-icon-1.png`,
  heading:`Cloud Services`,
  para:`Deliver plug commerce with dynamic is expertise. leading edge products with business models`,
},
{
  id:15,
  icon:`./Assets/icons/service-icon-1.png`,
  heading:`Cloud Services`,
  para:`Deliver plug commerce with dynamic is expertise. leading edge products with business models`,
},
{
  id:16,
  icon:`./Assets/icons/service-icon-1.png`,
  heading:`Cloud Services`,
  para:`Deliver plug commerce with dynamic is expertise. leading edge products with business models`,
},
{
  id:17,
  icon:`./Assets/icons/service-icon-1.png`,
  heading:`Cloud Services`,
  para:`Deliver plug commerce with dynamic is expertise. leading edge products with business models`,
},
{
  id:18,
  icon:`./Assets/icons/service-icon-1.png`,
  heading:`Cloud Services`,
  para:`Deliver plug commerce with dynamic is expertise. leading edge products with business models`,
},
{
  id:19,
  icon:`./Assets/icons/service-icon-1.png`,
  heading:`Cloud Services`,
  para:`Deliver plug commerce with dynamic is expertise. leading edge products with business models`,
},
]
export const Industries = (prop) => {
  return (
     <section className="Industries m-top m-btm" id='industries'>
            <div className="container">
            <div className="heading-box flex spce-btwn">
                      <div className="heading">
                            <span className="title">Industries</span>
                            <h2>Industries</h2>
                      </div>
                     <div className="visit-btn">
                         <a href="/" className="glbl-btn">View All Industries</a>
                     </div>
                </div>
              <div className="flex spce-btwn align-center">
                  {
                    mainservice.map((relEl, index)=>{
                      if(index < prop.activeCard){
                        return(
                              <div className="servicebox" key={relEl.id}>
                          <div className="service-bck">       
                          </div>
                          <div className="service-content">
                          <div className="service-icon">
                              <img src={relEl.icon} alt="/" />
                          </div>
                         <div className="service-text">
                           <h3>{relEl.heading}</h3>
                           <p>{relEl.para}</p>
                            <a href="/" className="glbl-btn">Read More</a>        
                         </div>
                          </div>
                              </div>
                             )
                           }
                           else{  
                            return
                          }
                    })}
              </div>
            </div>
     </section>    
  )
}
